import {useQuery} from "react-query";
import {PackDto} from "../models/interfaces/dtos/pack-dto.ts";
import {fetchItem} from "../queries/queries-helper.ts";
import ENDPOINTS from "../services/endpoints.ts";

const useProjectPacksDetails = (projectId: string) => 
    useQuery<PackDto[] | undefined>(
        ['project-packs', projectId],
        async () => fetchItem<PackDto[]>(ENDPOINTS.PROJECT_PACKS(projectId)),
        {
            enabled: !!projectId,
        }
    )

export default useProjectPacksDetails;